import { render, staticRenderFns } from "./AttachmentBadge.vue?vue&type=template&id=0412aee4&scoped=true"
import script from "./AttachmentBadge.vue?vue&type=script&lang=js"
export * from "./AttachmentBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0412aee4",
  null
  
)

export default component.exports